import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
export var search = function search(productType, query, limit) {
  var parsedQuery = query.replace(/&/g, '%26');
  return finectAPI({
    version: 'v4',
    path: "search/collectives/".concat(productType.api, "?q=").concat(parsedQuery, "&limit=").concat(limit),
    method: 'GET',
    onSuccess: function onSuccess(entity) {
      return entity.data;
    }
  });
};
export var fullSearch = function fullSearch(query, limit) {
  var parsedQuery = query.replace(/&/g, '%26');
  return finectAPI({
    version: 'v4',
    path: "search/products?q=".concat(parsedQuery, "&limit=").concat(limit, "&format=summary"),
    method: 'GET',
    onSuccess: function onSuccess(entity) {
      return entity.data;
    }
  });
};